import React, { FC, useEffect, useState } from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { Select } from 'antd';

import enFlag from 'src/assets/flags/us.png';
import esFlag from 'src/assets/flags/es.png';
import frFlag from 'src/assets/flags/fr.png';
import ptFlag from 'src/assets/flags/br.png';
import ruFlag from 'src/assets/flags/ru.png';

const LanguageSelect: FC<
  {
    onChange?: (value: string) => void;
    exclude?: string[];
    value?: string;
    allowClear?: boolean;
    stopEventPropagation?: boolean;
  } & WithTranslation
> = ({ t, onChange, exclude, value, allowClear = false, stopEventPropagation }) => {
  const [currentValue, setValue] = useState(value);
  const langs = [
    { key: 'en', value: t('English'), flag: enFlag },
    { key: 'es', value: t('Spanish'), flag: esFlag },
    { key: 'fr', value: t('French'), flag: frFlag },
    { key: 'ru', value: t('Russian'), flag: ruFlag },
    { key: 'pt', value: t('Portuguese'), flag: ptFlag },
  ];
  useEffect(() => {
    let nextValue = value || currentValue;
    if (nextValue && (exclude || []).includes(nextValue)) nextValue = undefined;
    setValue(nextValue);
  }, [exclude, value]); // eslint-disable-line react-hooks/exhaustive-deps

  const onSelect = (value: any) => {
    setValue(value);
    onChange && onChange(value);
  };

  return (
    <Select
      placeholder={t('SelectLanguage')}
      onChange={onSelect}
      style={{ width: '100%', height: '100%' }}
      showSearch
      value={currentValue}
      filterOption
      allowClear={allowClear}
      onClick={(e) => {
        if (stopEventPropagation) {
          e.preventDefault();
          e.stopPropagation();
        }
      }}
    >
      {langs
        .filter(({ key, value }) => ![key, value].some((x) => (exclude || []).includes(x)))
        .map(({ key, value, flag }) => (
          <Select.Option key={key} value={key}>
            <img src={flag} alt="" style={{ maxWidth: 32, position: 'relative', top: 6, marginRight: 4, left: -2 }} />
            <span>{t(value)}</span>
          </Select.Option>
        ))}
    </Select>
  );
};

export default withTranslation()(LanguageSelect);
